<template>
  <v-card flat>
    <v-list three-line v-if="listaHistorico.length">
      <v-list-item-group color="primary" v-model="selected">
        <template v-for="(item, index) in listaHistorico">
          <v-list-item :key="item.dataPesquisa" @click="buscar(item)">
            <template v-slot:default="{}">
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-bold grey--text text--darken-3"
                  v-text="item.termo"
                ></v-list-item-title>
                <v-list-item-subtitle>
                  Resultados:
                  <span class="font-weight-bold">
                    {{ item.resultados }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.tipo">
                  Tipo de documento:
                  <span class="font-weight-bold">
                    {{ item.tipo }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.numero">
                  Número:
                  <span class="font-weight-bold">
                    {{ item.numero }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.ano">
                  Ano:
                  <span class="font-weight-bold">
                    {{ item.ano }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.relator">
                  Relator:
                  <span class="font-weight-bold">
                    {{ item.relator }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.sessao_tipo">
                  Tipo de decisão:
                  <span class="font-weight-bold">
                    {{ item.sessao_tipo }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.classificacaoUnidadeTecnica">
                  Class. Unidade Téc.:
                  <span class="font-weight-bold">
                    {{ item.classificacaoUnidadeTecnica }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.classificacao_tematica">
                  Class. Temática:
                  <span class="font-weight-bold">
                    {{ item.classificacao_tematica }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.paradigmatica">
                  Paradigmática:
                  <span class="font-weight-bold">
                    {{ item.paradigmatica }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.assunto">
                  Palavras-chave:
                  <span class="font-weight-bold">
                    {{ item.assunto }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.ementa_voto">
                  Ementa do Voto/Excerto:
                  <span class="font-weight-bold">
                    {{ item.ementa_voto }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.emissor">
                  Emissor:
                  <span class="font-weight-bold">
                    {{ item.emissor }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.normativo">
                  Normativo:
                  <span class="font-weight-bold">
                    {{ item.normativo }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.artigo">
                  Artigo:
                  <span class="font-weight-bold">
                    {{ item.artigo }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.paragrafo">
                  Parágrafo:
                  <span class="font-weight-bold">
                    {{ item.paragrafo }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.inciso">
                  Inciso:
                  <span class="font-weight-bold">
                    {{ item.inciso }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.alinea">
                  Aílnea:
                  <span class="font-weight-bold">
                    {{ item.alinea }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.relevanciaText">
                  Relevância:
                  <span class="font-weight-bold">
                    {{ item.relevanciaText }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.publicacao">
                  Publicação:
                  <span class="font-weight-bold">
                    {{ item.publicacao }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Pesquisado em:
                  <span class="font-weight-bold">{{ item.dataPesquisa }}</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.hash">
                  <v-chip class="mt-2 mb-0" label small dark color="primary"
                    >COMPARTILHADO</v-chip
                  >
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <v-btn
                      fab
                      icon
                      elevation="0"
                      small
                      v-on="on"
                      @click.native.stop="deleteHistorico(item)"
                    >
                      <v-icon>
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar termo do histórico</span>
                </v-tooltip>
              </v-list-item-action>
            </template>
          </v-list-item>

          <v-divider
            v-if="index < listaHistorico.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
    <!-- <v-card v-else flat>
      <v-skeleton-loader v-bind="attrs" type="article"></v-skeleton-loader>
      <v-skeleton-loader v-bind="attrs" type="article"></v-skeleton-loader>
    </v-card> -->
  </v-card>
</template>
<script>
import Vue from "vue";
import _ from "lodash";

export default {
  props: { listaHistorico: {}, tipo: { type: String } },
  data() {
    return {
      attrs: null,
      selected: 0
    };
  },
  methods: {
    deleteHistorico(item) {
      const index = _.findKey(
        JSON.parse(Vue.localStorage.get(this.tipo) || "[]"),
        { dataPesquisa: item.dataPesquisa }
      );
      this.listaHistorico.splice(index, 1);
      localStorage.setItem(this.tipo, JSON.stringify(this.listaHistorico));

      const objeto = {
        text: "Pesquisa removida do histórico com sucesso",
        color: "success"
      };
      this.$store.commit("SET_SNACK_MESSAGE", objeto);
    },
    buscar(item) {
      item.historico = true;
      this.$emit("search", item);
    },
    zeraSelected() {
      this.selected = null;
    }
  },
  watch: {
    listaHistorico: {
      handler() {
        this.selected = null;
        setTimeout(this.zeraSelected, 10);
      }
    }
  }
};
</script>
